import styled from 'styled-components'

export const HighlightedContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.km2};
`

export const ContentCard = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${({ theme }) => theme.spacing.km4};
  padding: ${({ theme }) => `${theme.spacing.km4} ${theme.spacing.km6}`};
  min-height: 138px;
`

export const CardRow = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing.km6};

  & > *:not(:last-child) {
    margin-right: ${({ theme }) => theme.spacing.km6};
  }

  @media (max-width: 768px) {
    overflow-y: auto;
    flex-wrap: nowrap;
    gap: ${({ theme }) => theme.spacing.km6};

    div[role='region'] {
      flex: 60% 0 0;
      margin-right: 0px;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    div[role='region'] {
      flex: 80% 0 0;
    }
  }
`
